export const environment = {
  base_url: 'https://dev.api.associacao.dssystemas.com.br/api'
};
